import { Stack, Switch } from '@chronosphereio/chrono-ui';
import { AppMetadataProvider } from '../../../plugin-system';
import { useEventStoreContext } from '../../context';

type EventsListProps = {
  /**
   * If false, the variables will be wrapped in a Stack component.
   * @default false
   */
  disableContainer?: boolean;
};

export function EventsList(props: EventsListProps) {
  const { eventDefinitions, toggleEvent } = useEventStoreContext();

  const { disableContainer = false } = props;

  const renderList = () => {
    return (
      <>
        {eventDefinitions.map((event) => {
          if (event.spec.display?.hidden === true) {
            return null;
          }
          return (
            <AppMetadataProvider
              key={event.spec.name}
              metadata={{
                eventName: event.spec.name,
              }}
            >
              <Stack direction="row" alignItems="center">
                <div>{event.spec.name}</div>
                <Switch
                  checked={event.spec.enabled ?? true}
                  onChange={(__, checked) => {
                    toggleEvent(event.spec.name, checked);
                  }}
                />
              </Stack>
            </AppMetadataProvider>
          );
        })}
      </>
    );
  };

  if (disableContainer) {
    return <>{renderList()}</>;
  } else {
    return (
      <Stack direction="row" alignItems="center" flexWrap="wrap">
        {renderList()}
      </Stack>
    );
  }
}
